<template>
  <div class="expandDiv">
    <div v-if="getRowArr.length > 0">
      <!-- 以下为测试删除代码 -->
      <Table :columns="columns" :data="getRowArr">
        <template slot-scope="{ row, index }" slot="name">
          {{ accountName }}
        </template>
        <template slot-scope="{ row, index }" slot="delete">
          <span @click="handleDel(index)">
            <Button type="info" size="small" @click="rowClick(row)">{{
              $t("alarms.common.details")
            }}</Button>
            <Button type="error" size="small" @click="redisDelmodal = true">{{
              $t("alarms.common.delete")
            }}</Button>
          </span>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Array,
    accountIdString: String,
    accountName: String
  },
  data() {
    return {
      getRowArr: [],
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {}
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountTypes"),
          key: "accountTypeName"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "",
          slot: "name"
        },
        {
          title: this.$t("DocDBMonitor.ClusterIdentifier"),
          key: "dbInstanceIdentifier"
        },
        {
          title: this.$t("DocDBMonitor.role"),
          key: "roleName"
        },
        {
          title: this.$t("DocDBMonitor.status"),
          key: "status"
        },
        {
          title: this.$t("ElasticSearch.operation"),
          slot: "delete"
        }
      ]
    };
  },
  methods: {
    handleDel(index) {
      this.$emit("handleDelChild", index);
    }
  },
  watch: {
    row: {
      handler(newName, oldName) {
        this.getRowArr = newName;
      },
      immediate: true
    }
  },
  mounted() {},
  created() {}
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
.expandDiv >>> .ivu-table-header thead tr {
  display: none;
}
.expandDiv >>> .ivu-table-wrapper {
  /* border: none; */
  border-top-color: #fff;
  border-left-color: #fff;
  border-bottom-color: #fff;
}
.expandDiv >>> .ivu-table-expanded-cell {
  padding: 0;
}
.expandDiv >>> .ivu-table td {
  padding: 0 !important;
  border-bottom: none;
}
.expandDiv >>> .ivu-table-cell-with-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/TableExpand.vue